import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from '@/components/Layout';
import CircuitryOverlay from '@/components/CircuitryOverlay';
import WelcomeTour from '@/components/WelcomeTour';
import OracleInvitation from '@/components/OracleInvitation';
import StoreClerk from '@/components/StoreClerk';
import AutoReadingFace from '@/components/AutoReadingFace';
import KeyboardGiftEngine from '@/components/KeyboardGiftEngine';
import Home from '@/pages/Home';
import FederationHub from '@/pages/FederationHub';
import OracleBrain from '@/pages/OracleBrain';
import Codex from '@/pages/Codex';
import FederationNodes from '@/pages/FederationNodes';
import TokenCheckout from '@/pages/TokenCheckout';
import MerchGallery from '@/pages/MerchGallery';
import CryptoGuide from '@/pages/CryptoGuide';
import FederationManifest from '@/pages/FederationManifest';
import ResearchLab from '@/pages/ResearchLab';
import Rex from '@/pages/Rex';
import AgentZero from '@/pages/AgentZero';
import Council from '@/pages/Council';
import Radio from '@/pages/Radio';
import CodexPage from '@/pages/CodexPage';
import FloatingPortals from '@/components/FloatingPortals';
import '@/App.css';

function App() {
  const [showWelcomeTour, setShowWelcomeTour] = useState(false);

  const handleStartTour = () => {
    setShowWelcomeTour(true);
  };

  const handleCloseTour = () => {
    setShowWelcomeTour(false);
  };
  return (
    <>
      {/* Z-Index Layer 0: Tiling Background - Circuit Tech (Squared and Stacked) */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'url(/static/backgrounds/circuit-tech-bg.jpg)',
        backgroundSize: '100% auto',
        backgroundPosition: 'top center',
        backgroundRepeat: 'repeat-y',
        backgroundAttachment: 'fixed',
        zIndex: 0
      }}></div>
      
      {/* Z-Index Layer 10: Circuitry Overlay with Energy Pulses */}
      <CircuitryOverlay />
      
      {/* Z-Index Layer 20+: Scrollable Content with Glass Panels */}
      <div style={{ position: 'relative', minHeight: '100vh', zIndex: 20 }}>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hub" element={<FederationHub />} />
              <Route path="/oracle-brain" element={<OracleBrain />} />
              <Route path="/codex" element={<Codex />} />
              <Route path="/federation-nodes" element={<FederationNodes />} />
              <Route path="/tokens" element={<TokenCheckout />} />
              <Route path="/merch" element={<MerchGallery />} />
              <Route path="/crypto-guide" element={<CryptoGuide />} />
              <Route path="/federation" element={<FederationManifest />} />
              <Route path="/research" element={<ResearchLab />} />
              <Route path="/deep-ai" element={<ResearchLab />} />
              <Route path="/rex" element={<Rex />} />
              <Route path="/agent-zero" element={<AgentZero />} />
              <Route path="/council" element={<Council />} />
              <Route path="/radio" element={<Radio />} />
              <Route path="/codex" element={<CodexPage />} />
            </Routes>
            <FloatingPortals />
          </Layout>
          
          {/* Store Clerk - Persistent across all pages (inside Router context) */}
          <StoreClerk />
          
          {/* Auto-Reading Face (bottom-left) - Phase 7a */}
          <AutoReadingFace />
          
          {/* SFUI-004: Intelligent Onboarding - Non-blocking Oracle Invitation */}
          <OracleInvitation onAccept={handleStartTour} />
          
          {/* Welcome Tour Modal - Triggered by Oracle Invitation click */}
          <WelcomeTour isOpen={showWelcomeTour} onClose={handleCloseTour} />
          
          {/* Keyboard Gift Engine - Phase 7b */}
          <KeyboardGiftEngine />
        </BrowserRouter>
      </div>

      {/* Toast Notifications */}
      <Toaster position="top-right" theme="dark" />
    </>
  );
}

export default App;